import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["previewReport", "suppressActionsBar"];
import { canConvertToTableReport } from 'reporting-data/lib/convertToTableReport';
import { isConfigReport, isFunnelReport, isJourneyReport, isMultiConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import { FullPageSRVCheckboxTable } from '../FullPageSRVCheckboxTable';
import { SRVSummarizedTableSnowflakeReport } from './SRVSummarizedTableSnowflakeReport';
import JourneyReportSRVTable from './journey-table/JourneyReportSRVTable';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const showSRVSummarizedTable = report => {
  if (isFunnelReport(report) || isMultiConfigReport(report)) {
    return false;
  }
  if (isRelationalReport(report) && getReportChartType(report) !== TABLE) {
    return true;
  }
  return isConfigReport(report) && canConvertToTableReport(report) || isJourneyReport(report);
};
const SRVSummarizedTable = _ref => {
  let {
      previewReport,
      suppressActionsBar = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Both dataset and summary table are released together for snowflake reports
  if (isConfigReport(previewReport)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(FullPageSRVCheckboxTable, Object.assign({}, props, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      }))
    });
  } else if (isJourneyReport(previewReport)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(JourneyReportSRVTable, Object.assign({}, props, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      }))
    });
  } else if (isRelationalReport(previewReport)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(SRVSummarizedTableSnowflakeReport, Object.assign({}, props, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      }))
    });
  }
  return null;
};
export default SRVSummarizedTable;